import { render, staticRenderFns } from "./TableRequest.vue?vue&type=template&id=43d2c380"
import script from "./TableRequest.vue?vue&type=script&lang=js"
export * from "./TableRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports